import { OrderFeature, noop } from '@aloft/toolkit-shared';
import { Button, ButtonProps, Grid } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra -- we don't have replacements for these yet
import { Popover, PopoverContent, PopoverTrigger, Portal } from '@aloft/toolkit-sui/chakra';

import { DISCLOSABLE_FEATURES, FEATURES, Feature } from '../../../../redux/constants.ts';
import { selectIncludeCostApproach } from '../../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';

type AddFeaturesPopoverProps = {
  features: OrderFeature[] | Feature[];
  label: string;
  buttonProps?: Partial<ButtonProps>;
  handleAddFeature: (feature: Feature) => void;
};

export const AddFeaturesPopover = ({
  features,
  label,
  buttonProps,
  handleAddFeature,
}: AddFeaturesPopoverProps) => {
  const includeCostApproach = useAppSelector(selectIncludeCostApproach);
  const addableFeatures = DISCLOSABLE_FEATURES.filter(
    (feature) =>
      !features.includes(feature) && (includeCostApproach || feature !== 'manualCost'),
  );

  return (
  <Popover>
    {({ onClose }) => (
      <>
        <PopoverTrigger>
          <Button variant="inline" text={label} onClick={noop} {...buttonProps} />
        </PopoverTrigger>
        <Portal>
          <PopoverContent width="fit-content" zIndex={3}>
            <Grid
              gridTemplateColumns="repeat(3, 1fr)"
              padding="1rem"
              alignItems="flex-start"
              gap=".75rem"
              justifyItems="flex-start"
            >
              {addableFeatures.map(
                (feature) => (
                  <Button
                    key={feature}
                    variant="inline"
                    text={`+ ${FEATURES[feature].label}`}
                    onClick={() => {
                      handleAddFeature(feature);
                      onClose();
                    }}
                  />
                ),
              )}
            </Grid>
          </PopoverContent>
        </Portal>
      </>
    )}
  </Popover>
  );
};
